import { C, g as generateVid } from '../../dist/helper-b7763bea.esm.js';
export { C as config } from '../../dist/helper-b7763bea.esm.js';

/* eslint-disable import/no-extraneous-dependencies */
// vid middleware for node/express app
function visitorIdNode(option) {
  return function (req, res, next) {
    var opts = option || {};

    // if vid cookie is present call next
    if (req && req.cookies && req.cookies[C.CookieName]) {
      if (opts.debug) {
        console.info('DEBUG visitorIdNode: visitorId cookie is present in request');
      }

      // set visitor id to request.visitorId for accessing in other part of code
      req.vid = req.cookies[C.CookieName];
      return next();
    }
    if (opts.debug) {
      console.info('DEBUG visitorIdNode: visitorId cookie is not present in request');
    }

    // set the vid cookie and call next()
    var vid = generateVid();
    res.cookie(C.CookieName, vid, {
      maxAge: C.MaxAgeDay * 24 * 60 * 60 * 1000,
      // millisec
      domain: C.Domain
    });
    if (opts.debug) {
      console.info('DEBUG visitorIdNode: visitorId cookie has been set to response');
    }
    req.vid = vid;
    next();
    return true;
  };
}
var getVisitorIdNode = function getVisitorIdNode(req) {
  return req && req.vid ? req.vid : undefined;
};

export { getVisitorIdNode, visitorIdNode };
